import DensityMediumIcon from "@mui/icons-material/DensityMedium";
import { Divider } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import React, { useEffect, useState } from "react";
import BataiyoLogo from "../../assets/images/nav-white-logo.svg";
import { ROUTES } from "../../constant/routes";
import { navItems } from "../../constant/staticData";
import "./Navbar.css";
const Navbar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  const handleNavItemClick = (path) => {
    setIsDrawerOpen(false);
    if (path.startsWith("/#")) {
      const sectionId = path.substring(2);
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      window.location.href = path;
    }
  };

  const drawerList = (
    <div className="mob-line-icon">
      <List>
        {navItems?.map((item) => (
          <React.Fragment key={item?.id}>
            <a
              href={`/${item?.path}`}
              onClick={() => handleNavItemClick(`/${item?.path}`)}
              className="mob-nav-item-text"
            >
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => handleNavItemClick(`/${item?.path}`)}
                >
                  <ListItemText primary={item?.name} />
                </ListItemButton>
              </ListItem>
            </a>
            <Divider />
          </React.Fragment>
        ))}
      </List>
    </div>
  );

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`} id="nav">
      <div>
        <a href={`${ROUTES.HOME}#hero`}>
          <img
            src={BataiyoLogo}
            alt="bataiyo-logo"
            className="bataiyo-logo-img"
            loading="lazy"
          />
        </a>
      </div>
      <div className="nav-mobile-screen">
        <DensityMediumIcon
          onClick={toggleDrawer(true)}
          className="drawer-white-icon"
        />
      </div>
      <div className="nav-items">
        {navItems?.map((item) => (
          <div key={item?.id}>
            <a
              className="nav-item-text"
              href={`/${item?.path}`}
              onClick={() => handleNavItemClick(`/${item?.path}`)}
            >
              {item?.name}
            </a>
          </div>
        ))}
      </div>
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        {drawerList}
      </Drawer>
    </nav>
  );
};

export default Navbar;
